// extracted by mini-css-extract-plugin
export default {"body":"Input_body__6SOvG","label":"Input_label__-BwDO","input":"Input_input__9ccxQ","input--dynamic-label":"Input_input--dynamic-label__CIUHd","icon":"Input_icon__8Jdss"};